import { render, staticRenderFns } from "./Echart07M04.vue?vue&type=template&id=2b6aa0a7&"
import script from "./Echart07M04.vue?vue&type=script&lang=js&"
export * from "./Echart07M04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports